import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from "@material-ui/core";
import Message from "../Component/Message";
import Task from "../Component/Task";
import MediaFile from "../Component/MediaFile";
import UpLoadRequest from "../Component/UpLoadRequest";
import LinkForm from "../Component/LinkForm";
import text from "../../ChecklistCreate/SVG/email-2.svg";
import task from "../../ChecklistCreate/SVG/task.svg";
import mediafiles from "../../ChecklistCreate/SVG/attachment.svg";
import link from "../../ChecklistCreate/SVG/link.svg";
import upload from "../../ChecklistCreate/SVG/upload.svg";
import dependency from "../../ChecklistCreate/SVG/dependency.svg";
import DependencyTask from "../Component/DependencyTask";
import "./Expansion.scss";

const groupBy = (key) => (array) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

class Expansion extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getcurrentactivity = this.getcurrentactivity.bind(this);
  }

  getImageFromComponentType = (activity) => {
    switch (activity.activitytypeid) {
      case 1:
        return text;
      case 2:
        return task;
      case 3:
        return mediafiles;
      case 4:
        return link;
      case 5:
        return upload;
      case 6:
        return dependency;
      default:
        return text;
    }
  };

  getHeaderType = (activity) => {
    switch (activity.activitytypeid) {
      case 1:
        return "Welcome Message";
      case 2:
        return "Task";
      case 3:
        return "Media File";
      case 4:
        return "Link";
      case 5:
        return "Upload Request";
      case 6:
        return "Dependency Task";
      default:
        return "Message";
    }
  };

  getcurrentactivity(
    activity,
    postData,
    isShared,
    selectedChecklist,
    reloadChecklistOnDone,
  ) {
    switch (activity.activitytypeid) {
      case 1:
        return (
          <Message
            postData={postData}
            activityObject={activity}
            isShared={isShared}
            checklist={selectedChecklist}
            reloadChecklistOnDone={reloadChecklistOnDone}
          />
          // pass method and data
        );
      case 2:
        return (
          <Task
            postData={postData}
            activityObject={activity}
            isShared={isShared}
            checklist={selectedChecklist}
            reloadChecklistOnDone={reloadChecklistOnDone}
          />
          // pass method and data
        );
      case 3:
        return (
          <MediaFile
            postData={postData}
            activityObject={activity}
            isShared={isShared}
            checklist={selectedChecklist}
            reloadChecklistOnDone={reloadChecklistOnDone}
          />
          // pass method and data
        );
      case 4:
        return (
          <LinkForm
            postData={postData}
            activityObject={activity}
            isShared={isShared}
            checklist={selectedChecklist}
            reloadChecklistOnDone={reloadChecklistOnDone}
          />
          // pass method and data
        );
      case 5:
        return (
          <UpLoadRequest
            postData={postData}
            activityObject={activity}
            isShared={isShared}
            checklist={selectedChecklist}
            reloadChecklistOnDone={reloadChecklistOnDone}
          />
          // pass method and data
        );
      case 6:
        return (
          <DependencyTask
            postData={postData}
            key={selectedChecklist.empchecklistid}
            activityObject={activity}
            isShared={isShared}
            checklist={selectedChecklist}
            reloadChecklistOnDone={reloadChecklistOnDone}
          />
          // pass method and data
        );
      default:
        return null;
    }
  }

  render() {
    const { checklistactivity } = this.props.postData;
    console.log("this.props.postData: ", this.props.postData);
    console.log("this.props.selectedChecklist: ", this.props.selectedChecklist);
    console.log("checklistactivity: ", checklistactivity);
    console.log("reloadChecklistOnDone: ", this.props.reloadChecklistOnDone);
    const groupByDueDays = groupBy("duedays");
    const ExpansionData = groupByDueDays(checklistactivity);
    return (
      <Grid item xs={12} className="expansionCompletionContainer">
        {Object.keys(ExpansionData).map((daysKey) => (
          <Grid container xs={12} className="perDaySection" key={daysKey}>
            <Grid item xs={1} className="dayText">
              <p>DAY</p>
              <p>{daysKey}</p>
            </Grid>
            <Grid item xs={11}>
              {ExpansionData[daysKey].map((activity, index) => (
                <ExpansionPanel
                  key={`${index}-${activity.title}`}
                  classes={{
                    root: "ExpansionRoot",
                    expanded: "ExpansionRootExpanded",
                  }}
                >
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    classes={{
                      root: "summaryRoot",
                      expanded: "summaryExpanded",
                      content: activity.isdone
                        ? "summaryContent striked"
                        : "summaryContent",
                    }}
                  >
                    <img
                      src={this.getImageFromComponentType(activity)}
                      alt="message icon"
                    />
                    <Typography className="ellipsis width100">
                      {" "}
                      {this.getHeaderType(activity)} - {activity.title}
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Grid style={{ width: "100%" }}>
                      {this.getcurrentactivity(
                        activity,
                        this.props.postData,
                        this.props.isShared,
                        this.props.selectedChecklist,
                        this.props.reloadChecklistOnDone,
                      )}
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  }
}
export default Expansion;
